<div class="pad-1" [style.background-color]="themedata.primarytheme">
    <div class="chatmodalheader">
        <div class="imagediv">
            <img [appLazyLoadImage]="'../../assets/images/mainlogo.png'" alt="">
        </div>
        <!-- <div class="ml-2">
            <mat-icon class="closebutton" (click)="closeChatModal()" [style.color]="themedata.color"> close </mat-icon>
        </div> -->
    </div>
    <div class="chatmodalcontainer mt-2 mb-2" [style.background-color]="themedata.cardbg">
        <mat-list>
            <mat-list-item class="sentmessage">
                <div matListItemTitle [style.background-color]="themedata.primarybg" class="message">
                    <span [style.color]="themedata.color">
                        {{"Hey"}}
                    </span>
                </div>
            </mat-list-item>
            <mat-list-item class="receivedmessage">
                <div matListItemTitle [style.background-color]="themedata.primarybg" class="message">
                    <span [style.color]="themedata.color">
                        {{"Hello! How can I help?"}}
                    </span>
                </div>
            </mat-list-item>
        </mat-list>
    </div>
    <div class="chatmodalfooter mt-2">
        <form [formGroup]="messageForm" class="w-100">
            <mat-form-field appearance="fill" class="chatinput" [style.color]="themedata.color">
                <input matInput type="text" formControlName="message" placeholder="Type a message..." />
            </mat-form-field>
        </form>

        <button mat-raised-button class="sendbutton" (click)="sendMessage()"
            [style.background-color]="themedata.primarybg">
            <mat-icon>send</mat-icon>
        </button>
    </div>
</div>